module.exports = __webpack_public_path__ + "static/media/azure_cosmos_db.74849076.svg";